import { render, staticRenderFns } from "./fblogin.vue?vue&type=template&id=a2bb3d32"
import script from "./fblogin.vue?vue&type=script&lang=js"
export * from "./fblogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports